<div id="header">
  <button data-e2e="toogle-menu" role="button" class="btn-menu" (click)="OnToggleMenuClick()">
    <mat-icon data-e2e="icon_main_menu" aria-hidden="true" svgIcon="main_menu"></mat-icon>
    <span class="sr-only">{{ 'accessibility.header.menu' | translate }}</span>
  </button>

  @if (IsConnectPage() || (canBack$ | async)) {
    <button data-e2e="back-button" role="button" class="btn-back"
      (click)="onBackClick()">
      <mat-icon aria-hidden="true" svgIcon="back"></mat-icon>
      <span class="sr-only">{{ 'accessibility.header.back' | translate }}</span>
    </button>
  }

  <app-progress data-e2e="progress-wins" [level]="level$ | async" [coins]="coins$ | async"
  [img]="'coin'"></app-progress>

  @if (selectedLanguage$ | async; as selectedLanguage) {
    @if (showTranslateMenu ) {
      <button mat-button fxHide fxShow.gt-xs
        data-e2e="header-translate-menu"
        class="language-button"
        [matMenuTriggerFor]="languageMenu">
        <div fxLayout="row" fxLayoutAlign="center center">
          @if (!showFlagImg) {
            <mat-icon class="mr-8" svgIcon="earth"></mat-icon>
          }
          @if (showFlagImg) {
            <img class="flag mr-8"
              src="assets/{{ brand }}/images/flags/{{ selectedLanguage.flag }}.png" alt="">
            }
            <span>{{ selectedLanguage.id }}</span>
          </div>
        </button>
      }
    }

    <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

      @for (lang of languages; track lang) {
        <button mat-menu-item (click)="OnLanguageClick(lang)"
          data-e2e="header-language">
          <span fxLayout="row" fxLayoutAlign="start center">
            @if (showFlagImg) {
              <img class="flag mr-16" src="assets/{{ brand }}/images/flags/{{lang.flag}}.png"
                alt="">
            }
            <span class="iso">{{ lang.title }}</span>
          </span>
        </button>
      }

    </mat-menu>

  </div>
